import { useState } from 'react';
import { useNavigate } from 'react-router';
import { FaArrowDown, FaExpandArrowsAlt, FaCheckCircle, FaBook } from 'react-icons/fa';
import { CtaButtons } from '../components/landing';
import { PillButtons, Input, Button } from '../components/input';
import { CodeBlock } from '../components/code';
import { RunCrawl, RunExtract, RunScrape } from '../components/run';
import { narrow } from '../shared';
import { useGlobal } from '../state';
import { discordUrl, colors } from '../constants';

const headerStyle = {
  fontWeight: 'bold',
  fontSize: 26,
  textAlign: 'center',
};

const subHeaderStyle = {
  textAlign: 'center',
  fontSize: 22,
  fontWeight: 'bold',
  marginBottom: 20,
};

const McpChoices = () => {
  const [tab, setTab] = useState('python');

  const choices = [['python', 'Python (pydantic)']];

  const code = {
    python: `# pip install pydantic-ai

from pydantic_ai import Agent
from pydantic_ai.mcp import MCPServerStreamableHTTP
from pydantic import BaseModel

fetchfox = MCPServerStreamableHTTP(
    url='https://mcp.fetchfox.ai/mcp',
    headers={"Authorization": "Bearer YOUR_API_KEY"})

agent = Agent('openai:gpt-4o', toolsets=[fetchfox])
result = agent.run_sync(
  'Scrape https://pokemondb.net/pokedex/* for 10 pokemon names and numbers'
)`,
    javascript: `// npm install modelcontextprotocol

import { Client } from "modelcontextprotocol/client";
import { HTTPServerTransport } from "modelcontextprotocol/transport/http";

async function run() {
  const client = new Client(
    { name: "demo", version: "1.0.0" },
    new HTTPServerTransport({ url: "http://localhost:3000/mcp" })
  );

  await client.connect();
  console.log(await client.listTools());

  const result = await client.callTool("echo", { message: "hi" });
  console.log(result);

  await client.close();
}

run();
`,
  };

  return (
    <>
      <PillButtons choices={choices} value={tab} onChange={setTab} />
      <CodeBlock language={tab}>{code[tab]}</CodeBlock>
      <FaArrowDown size="36" color="#888" />
    </>
  );
};

const ApiCall = () => {
  const [tab, setTab] = useState('python');

  const codeStyle = {
    // display: 'inline-block',
    // width: 560,
    // whiteSpace: 'pre',
    // fontFamily: 'monospace',
    // background: '#f3f3f3',
    // borderRadius: 4,
  };

  const choices = [
    ['python', 'Python'],
    ['javascript', 'JavaScript'],
    ['mcp', 'MCP Server'],
    ['pydantic', 'Pydantic'],
    ['bash', 'curl'],
  ];

  const code = {
    python: `# pip install fetchfox-sdk

from fetchfox_sdk import FetchFox

fox = FetchFox(api_key="YOUR_API_KEY")

data = fox.scrape({
  "pattern": 'https://www.reddit.com/r/*/comments/*',
  "template": "username, comment, points",
})`,

    javascript: `// npm install fetchfox-sdk

import * as fox from 'fetchfox-sdk';

fox.configure({ apiKey: 'YOUR_API_KEY' })

const data = await fox.scrape({
  pattern: 'https://www.reddit.com/r/*/comments/*',
  template: 'username, comment, points'
})`,

    mcp: `{
  "url": "https://mcp.fetchfox.ai/mcp",
  "transport": {
    "type": "http",
    "headers": {
      "Authorization": "Bearer YOUR_API_KEY"
    }
}

# And then ask your agent to scrape something`,

    pydantic: `from pydantic_ai import Agent
from pydantic_ai.mcp import MCPServerStreamableHTTP

fetchfox = MCPServerStreamableHTTP(
    url='https://mcp.fetchfox.ai/mcp',
    headers={"Authorization": "Bearer YOUR_API_KEY"})

agent = Agent('openai:gpt-4o', toolsets=[fetchfox])
result = agent.run_sync(
  'Scrape username, text, and points from '
  'https://www.reddit.com/r/*/comments/*')`,

    bash: `curl -X POST https://api.fetchfox.ai/api/scrape \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer $FETCHFOX_API_KEY" \\
  -d '{"pattern":"https://www.reddit.com/r/*/comments/*",
       "template": "username, comment, points"}'`,
  };

  const language =
    {
      mcp: 'bash',
      pydantic: 'python',
    }[tab] || tab;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
      <br />

      <div style={subHeaderStyle}>Scrape millions of pages with one line of code</div>
      <PillButtons choices={choices} value={tab} onChange={setTab} />

      <CodeBlock language={language}>{code[tab]}</CodeBlock>
      <FaArrowDown size="36" color="#888" />

      {/*tab == 'mcp' && <McpChoices />*/}

      <CodeBlock language="json">
        {`{
    "username": "BobbyUser",
    "comment_text": "AI + FetchFox = 🤩",
    "points": 888
}`}
      </CodeBlock>

      <div style={{ color: '#888', fontSize: 14, margin: '40px 0 0 0' }}>🪦 BeautifulSoup 2004-2025, RIP</div>
    </div>
  );
};

//   Scrape <mark>any site</mark>
// </div>
// <div style={headerStyle}>
//   with <mark>just a prompt</mark>

const StartPrompt = () => {
  const navigate = useNavigate();
  const [url, setUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/sandbox', { state: { url } });
  };

  return (
    <div style={{ width: '100%', maxWidth: 640 }}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 5, position: 'relative', width: '100%' }}>
        <Input
          style={{ width: '100%' }}
          type="text"
          placeholder="https://..."
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <div style={{}}>
          <Button>Start</Button>
        </div>
      </form>
    </div>
  );
};

export function LandingCurrent() {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          marginx: '40px auto 80px auto',
          height: '60vh',
        }}
      >
        <div style={{ flex: 1 }}></div>
        <div>
          <img src="/logo-fox.svg" style={{ width: 50, marginBottom: 10 }} />
        </div>
        {/*
        <div style={headerStyle}>
          Scrape <mark>any site</mark> with just <mark>a prompt</mark>
        </div>
        */}
        <div style={headerStyle}>Scrape any site with just a prompt</div>
        <div style={{ color: '#444', textAlign: 'center', fontSize: 22, marginBottom: 10 }}>
          An AI scraper for developers
        </div>

        <StartPrompt />
        <div style={{ flex: 2 }}></div>

        {/*
        <div style={{ fontSize: 15, textAlign: 'center', color: '#777' }}>
          Scrape <b style={{ color: '#555' }}>millions of pages</b> and convert them into <br /> structured data with
          just <b style={{ color: '#555' }}>one line of code</b>.
        </div>
        */}
      </div>

      {narrow(<ApiCall />)}

      <br />
      <br />

      <CtaButtons />
      <br />
      <br />
      <br />

      <div style={{ margin: '40px auto 200px auto', width: 640, textAlign: 'center', fontSize: 18 }}>
        FetchFox is a new
        <div style={{ margin: '18px 0 10px 0' }}>
          <FaArrowDown size="24" color="#aaa" />
        </div>
        Get free 1:1 support on{' '}
        <a href={discordUrl} className="bold">
          Discord
        </a>{' '}
        or at{' '}
        <a href="mailto:help@fetchfoxai.com" className="bold">
          help@fetchfoxai.com
        </a>
      </div>
    </div>
  );
}

export default LandingCurrent;
